<template>
  <div class="phone-model-select-container">
    <h3 class="product-title">{{ title }}</h3>

    <div class="main-container justify-items-center">
      <div class="imgs-container">
        <div
          class="cloudimage-360"
          id="phone-360"
          :data-folder="'/assets/360_degree/' + name + '/'"
          data-filename-x="{index}.jpg"
          :data-amount-x="showed_image_amount"
        ></div>
      </div>

      <div class="selector-container">
        <h4 class="title">{{ subtitle }}</h4>

        <div class="field">
          <label class="label" for="brand-select">Brand</label>
          <select
            id="brand-select"
            class="select"
            v-model="selectedBrand"
            @change="onBrandChange"
          >
            <option v-for="brand in brandsList" :key="brand" :value="brand">
              {{ brand }}
            </option>
          </select>
        </div>

        <div class="field">
          <label class="label" for="model-select">Model</label>
          <select
            id="model-select"
            class="select"
            v-model="selectedModel"
            :disabled="!selectedBrand"
            @change="emitSelection"
          >
            <option v-for="model in availableModels" :key="model" :value="model">
              {{ model }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="button-container">
      <button class="actionButton" @click="cancel">Back</button>
      <button class="actionButton" :disabled="!selectedModel" @click="next">Next</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneCaseModelSelector',
  props: {
    name: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Phone Case'
    },
    subtitle: {
      type: String,
      default: 'Please select your phone brand and model'
    },
    showed_image_amount: {
      type: Number,
      default: 36
    },
    brands: {
      type: Array,
      default: () => ['Samsung', 'iPhone', 'Google Pixel']
    },
    modelsByBrand: {
      type: Object,
      default: () => ({
        iPhone: [
          'iPhone 7', 'iPhone 8', 'iPhone 8 Plus', 'iPhone X', 'iPhone XR', 'iPhone XS', 'iPhone XS Max',
          'iPhone 11', 'iPhone 11 Pro', 'iPhone 12', 'iPhone 12 Pro', 'iPhone 13', 'iPhone 13 Pro',
          'iPhone 14', 'iPhone 14 Pro', 'iPhone 15', 'iPhone 15 Pro', 'iPhone 16', 'iPhone 16 Pro',
          'iPhone 17', 'iPhone 17 Pro'
        ],
        Samsung: [
          'Galaxy S21', 'Galaxy S22', 'Galaxy S23', 'Galaxy S24', 'Galaxy S25'
        ],
        'Google Pixel': [
          'Pixel 7', 'Pixel 7a', 'Pixel 8', 'Pixel 8a', 'Pixel 9', 'Pixel 9a'
        ]
      })
    },
    preselected: {
      type: Object,
      default: () => ({ brand: '', model: '' })
    },
    // NEW: Accept pre-selected model (for restoration from saved data)
    preSelectedModel: {
      type: Object,
      default: () => null
    }
  },
  data() {
    // Use preSelectedModel if provided, otherwise use preselected
    const modelToUse = this.preSelectedModel || this.preselected;
    
    if (this.preSelectedModel) {
      console.log('🔄 PhoneCaseModelSelector: Restoring pre-selected model:', this.preSelectedModel);
    }
    
    return {
      brandsList: this.brands,
      selectedBrand: modelToUse.brand || (this.brands[0] || ''),
      selectedModel: modelToUse.model || ''
    }
  },
  watch: {
    preSelectedModel(newModel) {
      if (newModel && newModel.brand && newModel.model) {
        console.log('🔄 PhoneCaseModelSelector: Model updated via prop:', newModel);
        this.selectedBrand = newModel.brand;
        this.selectedModel = newModel.model;
        this.emitSelection();
      }
    }
  },
  computed: {
    availableModels() {
      const models = this.modelsByBrand[this.selectedBrand] || []
      if (this.selectedModel && !models.includes(this.selectedModel)) {
        this.selectedModel = ''
      }
      return models
    }
  },
  methods: {
    onBrandChange() {
      this.selectedModel = ''
      this.emitSelection()
    },
    emitSelection() {
      this.$emit('updateSelection', { brand: this.selectedBrand, model: this.selectedModel })
    },
    next() {
      if (!this.selectedModel) return
      this.$emit('next', { brand: this.selectedBrand, model: this.selectedModel })
    },
    cancel() {
      this.$emit('cancel', 'cancel')
    }
  },
  mounted() {
    if (window && window.CI360 && typeof window.CI360.init === 'function') {
      window.CI360.init()
    }
  }
}
</script>

<style scoped>
.phone-model-select-container {
  max-width: 50vw;
  margin: 0 auto;
  width: 100%;
}
.button-container {
  display: flex;
  justify-content: space-between;
  margin-top: 1vw;
}
.button-container > :first-child {
  transform: translateX(-100%);
}

.button-container > :last-child {
  transform: translateX(100%);
}
.main-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1vw;
}
.product-title {
  margin-top: 5.5vw;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 24.65vw;
  height: 2.15vw;
  font-size: 2.75vw;
  font-family: BaskervilleDisplayPT, BaskervilleDisplayPT-Bold;
  font-weight: 700;
  text-align: center;
  color: #514f4c;
}
.imgs-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4.15vw;
  border-radius: 1.6667vw;
  width: 25vw;
  height: 25vw;
  overflow: hidden;
}
.selector-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4.15vw;
}
.title {
  height: 1.55vw;
  font-size: 2.05vw;
  font-family: Glacial Indifference, Glacial Indifference-Italic;
  font-weight: 400;
  text-align: center;
  color: #000000;
  line-height: 2.05vw;
}
.field {
  width: 25vw;
  display: flex;
  flex-direction: column;
  margin-top: 4.2vw;
}
.label {
  font-size: 1.05vw;
  margin-bottom: 0.4vw;
  color: #514f4c;
}
.select {
  width: 100%;
  height: 2.6vw;
  padding: 0 0.8vw;
  border-radius: 0.6vw;
  border: 0.05vw solid #000000;
  background: #ffffff;
  font-size: 1.2vw;
  color: #000000;
}
.actionButton {
  width: 8vw;
  height: 2.05vw;
  border-radius: 1.025vw;
  background: #cfc5b3;
  color: black;
  border: none;
  font-size: 1.4vw;
  font-family: Glacial Indifference, Glacial Indifference-Bold;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
  margin-top: 1vw;
}
.actionButton:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
@media screen and (max-width: 768px) {
  .main-container {
    grid-template-columns: 1fr;
    place-items: center;
  }
  .phone-model-select-container {
    max-width: 100vw;
  }
  .product-title {
    margin-top: 10.4167vw;
    height: 9.1146vw;
    width: 120%;
    font-size: 7.1615vw;
    font-family: BaskervilleDisplayPT, BaskervilleDisplayPT-Bold;
    font-weight: 700;
    text-align: center;
    color: #514f4c;
  }
  .imgs-container {
    margin-top: 4.9479vw;
    height: 67.7083vw;
    width: 67.7083vw;
  }
  .selector-container {
    margin-top: 4.9479vw;
  }
  .title {
    font-size: 4.9479vw;
    line-height: 5.599vw;
    height: 5.4688vw;
  }
  .field {
    width: 80vw;
    margin-top: 4vw;
  }
  .label {
    font-size: 3.5vw;
    margin-bottom: 1.5vw;
  }
  .select {
    height: 10vw;
    border-radius: 2vw;
    font-size: 4vw;
    padding: 0 3vw;
  }
  .button-container {
    margin-top: 18.2292vw;
  }
  .button-container > :first-child {
    transform: translateX(100%);
  }

  .button-container > :last-child {
    transform: translateX(-100%);
  }
  .actionButton {
    width: 19.0104vw;
    height: 4.9479vw;
    border-radius: 2.474vw;
    font-size: 3.2552vw;
  }
}
</style>


